/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BillStatusEnum as DigiworkMaitreDDomenModelBillStatusEnum } from '../../models/Digiwork/MaitreD/Domen/Model/bill-status-enum';
import { OrderTypeEnum as DigiworkMaitreDDomenModelOrderTypeEnum } from '../../models/Digiwork/MaitreD/Domen/Model/order-type-enum';
import { OrdersDto as DigiworkMaitreDPosDtoOrderV2OrdersDto } from '../../models/Digiwork/MaitreD/Pos/DTO/OrderV2/orders-dto';

export interface GetOrders$Params {
  venueId?: string;
  tableId?: string;
  waiterId?: string;
  billStatus?: DigiworkMaitreDDomenModelBillStatusEnum;
  date?: string;
  orderType?: DigiworkMaitreDDomenModelOrderTypeEnum;
}

export function getOrders(http: HttpClient, rootUrl: string, params?: GetOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrdersDto>> {
  const rb = new RequestBuilder(rootUrl, getOrders.PATH, 'get');
  if (params) {
    rb.query('venueId', params.venueId, {});
    rb.query('tableId', params.tableId, {});
    rb.query('waiterId', params.waiterId, {});
    rb.query('billStatus', params.billStatus, {});
    rb.query('date', params.date, {});
    rb.query('orderType', params.orderType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrdersDto>;
    })
  );
}

getOrders.PATH = '/api/orders';
